import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAuth } from '../context/AuthContext';

/**
 * ImpersonationBanner - Displays subtle banner when admin is impersonating a user
 * Shows at top of viewport with background color matching app theme
 */
const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUserEmail, exitImpersonation } = useAuth();

  // Don't render if not impersonating
  if (!isImpersonating) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        backgroundColor: '#161c3e', // Same as app background.paper
        color: 'white',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, color: 'white' }}>
          Admin Impersonation Mode
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          Viewing as: <strong>{impersonatedUserEmail || 'Unknown User'}</strong>
        </Typography>
      </Box>

      <Button
        variant="outlined"
        startIcon={<ExitToAppIcon />}
        onClick={exitImpersonation}
        sx={{
          borderColor: 'rgba(255, 255, 255, 0.3)',
          color: 'white',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: '4px',
          padding: '6px 16px',
          '&:hover': {
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'translateY(-1px)'
          },
          transition: 'all 0.2s ease-in-out'
        }}
      >
        Exit Impersonation
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
